function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 2.25a.75.75 0 01.75-.75h4.5a.75.75 0 01.75.75v19.5a.75.75 0 01-.75.75h-4.5a.75.75 0 01-.75-.75V2.25zM10.5 21V3h3v18h-3zM17.25 8.25a.75.75 0 00-.75.75v12.75c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75V9a.75.75 0 00-.75-.75h-4.5zm.75 1.5V21h3V9.75h-3zM2.25 13.5a.75.75 0 00-.75.75v7.5c0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75v-7.5a.75.75 0 00-.75-.75h-4.5zM3 15v6h3v-6H3z",
  fill: "currentColor"
})));